export const HOME_TITLE = 'Welcome to Your Podcast’s Performance Dashboard';

export const HOME_SUBTITLE =
  'Seamlessly manage your data, measure your success, and grow your podcast.';
